import { render, staticRenderFns } from "./BaseBulkActionsBar.vue?vue&type=template&id=f3b9e3ea&scoped=true"
import script from "./BaseBulkActionsBar.vue?vue&type=script&lang=js"
export * from "./BaseBulkActionsBar.vue?vue&type=script&lang=js"
import style0 from "./BaseBulkActionsBar.vue?vue&type=style&index=0&id=f3b9e3ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9e3ea",
  null
  
)

export default component.exports